import React, { ChangeEvent, useEffect, useId, useRef } from 'react';

import Checkbox from '@ingka/checkbox';
import styled from '@emotion/styled';
import { theme } from '../styles/core/theme';

export const StyledIndeterminateCheckBox = styled(Checkbox)`
   input[type='checkbox']:checked:not([disabled]) ~ .checkbox__symbol,
   input[type='checkbox']:indeterminate ~ .checkbox__symbol {
      background-color: ${theme.colors.text.tertiary} !important;
      border-color: ${theme.colors.text.tertiary} !important;
   }

   input[type='checkbox']:checked:hover:not([disabled]) ~ .checkbox__symbol,
   input[type='checkbox']:indeterminate:hover ~ .checkbox__symbol {
      background-color: ${theme.colors.text.primary} !important;
      border-color: ${theme.colors.text.primary} !important;
   }
`;

interface IndeterminateCheckboxProps {
   onChange?: ((e: ChangeEvent) => void) | undefined;
   checked?: boolean | undefined;
   title?: string | undefined;
   indeterminate?: boolean | undefined;
   disabled?: boolean | undefined;
}

export const IndeterminateCheckbox = ({ onChange, checked, title, indeterminate, disabled }: IndeterminateCheckboxProps) => {
   const checkboxId = useId();
   const checkBoxRef = useRef<HTMLInputElement>(null);

   useEffect(() => {
      if (checkBoxRef.current) {
         checkBoxRef.current.indeterminate = !checked ? indeterminate! : false;
      }
   }, [checkBoxRef, checked, indeterminate]);

   return (
      <StyledIndeterminateCheckBox
         checked={checked}
         ref={checkBoxRef}
         id={checkboxId}
         value={''}
         title={title}
         onChange={onChange}
         disabled={disabled}
         onClick={(e) => e.stopPropagation()}
      />
   );
};
